// Metadata verified against Crossref. The `link` is the JOSS paper DOI, not the
// Zenodo software-archive DOI that the review issues also list.
const publications = [
  {
    title: 'Discovering the SUPER in computing: dagster-slurm for reproducible research on HPC',
    authors: 'Picatto, H., Heß, M., Heiler, G., & Pfister, M.',
    journal: 'Journal of Open Source Software',
    volume: 11,
    issue: 119,
    page: 9795,
    year: 2026,
    doi: '10.21105/joss.09795',
    link: 'https://doi.org/10.21105/joss.09795',
  },
  {
    title: 'Cost-Effective Big Data Orchestration Using Dagster: A Multi-Platform Approach',
    authors: 'Picatto, H., Heiler, G., & Klimek, P.',
    journal: 'Journal of Open Source Software',
    volume: 11,
    issue: 119,
    page: 7695,
    year: 2026,
    doi: '10.21105/joss.07695',
    link: 'https://doi.org/10.21105/joss.07695',
  },
];

export default publications;
